import { Pipe, PipeTransform, QueryList } from '@angular/core';

@Pipe({
  name: 'queryListToArray'
})
export class QueryListToArrayPipe implements PipeTransform {
  transform<T>(panels: QueryList<T>): T[] {
    return panels.toArray();
  }
}
